export const API_URL_DEV = "https://localhost:44301/";
export const API_URL_PROD = "http://accountsapi.alfascino.in/";
// export const API_URL_PROD = "http://accountsapi.coyotx.com/";
